import { render, staticRenderFns } from "./baseCardList.vue?vue&type=template&id=735b2dd0&scoped=true"
import script from "./baseCardList.vue?vue&type=script&lang=ts"
export * from "./baseCardList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b2dd0",
  null
  
)

export default component.exports